import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPhoto = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M2.615 3.2h26.77A2.624 2.624 0 0 1 32 5.801V26.2a2.62 2.62 0 0 1-2.615 2.6H2.615A2.62 2.62 0 0 1 0 26.2V5.8a2.624 2.624 0 0 1 2.615-2.6zm0 1.92a.704.704 0 0 0-.695.681v14.753L8 10.765c.759-1.219 1.996-1.219 2.755 0l7.299 11.731v-.016l1.347 2.381h1.86l-2.24-3.975 2.921-4.8c.752-1.232 1.978-1.232 2.727 0l5.411 8.915v-19.2a.704.704 0 0 0-.695-.681zm20.08 6.707a2.429 2.429 0 1 0 0-4.857 2.429 2.429 0 0 0 0 4.857z" clipRule="evenodd" /></svg>;
export default SvgPhoto;